import * as React from "react";

export class DateTime extends React.Component<{ date?: string, time?: string }, {}> {
    render() {
        return (
            <div className="rj-racing-future-events__date-time">
                <span>{this.props.date}</span>
                <span>&#x2002;-&#x2002;</span>
                <span>{this.props.time}</span>
            </div>
        )
    }
}